import { BaseService } from "../baseService";
import { BrandAPIService } from "./brandAPIService";

class BrandService extends BaseService<BrandAPIService> {
  async getBrandSubmissions(params?: {
    status?: string;
    bpOwner?: string;
    brandName?: string;
  }): Promise<{ items: any[] }> {
    return await this.apiService.getBrandSubmissions(params);
  }

  async getBrandSubmissionById(id: string): Promise<any> {
    return await this.apiService.getBrandSubmissionById(id);
  }

  async patchBrandSubmissionDecision(
    id: string,
    body: { decision: "APPROVE" | "REJECT"; reason?: string }
  ): Promise<any> {
    return await this.apiService.patchBrandSubmissionDecision(id, body);
  }

  async patchBrandSubmissionPdpAssignee(id: string, body: { pdpAssignee: "Fiona" | "Thania" | null }): Promise<any> {
    return await this.apiService.patchBrandSubmissionPdpAssignee(id, body);
  }

  async patchBrandSubmissionComplianceReview(
    id: string,
    body: { productId: string; complianceCategorisation: "Food Supplement" | "Food" | "Hybrid" }
  ): Promise<any> {
    return await this.apiService.patchBrandSubmissionComplianceReview(id, body);
  }

  async patchSubmissionVendor(id: string, body: { vendorId: string }): Promise<any> {
    return await this.apiService.patchSubmissionVendor(id, body);
  }

  async getVendorSearch(q: string): Promise<{ items: Array<{ id: string; name: string }> }> {
    return await this.apiService.getVendorSearch(q);
  }
}

export { BrandService };
